import { render, staticRenderFns } from "./OutboundImport.vue?vue&type=template&id=16ada5c8&"
import script from "./OutboundImport.vue?vue&type=script&lang=ts&"
export * from "./OutboundImport.vue?vue&type=script&lang=ts&"
import style0 from "./OutboundImport.vue?vue&type=style&index=0&id=16ada5c8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports